import {PopupVo} from '../../common/shared/api/gateway/popup/PopupVo.interface';
import {Popup} from '../generated/types';

/**
 * TODO: 현재 메인 팝업 쪽에서 웰컴 팝업 쪽만 가져오고 있습니다. 메인 팝업 진행시 변경이 필요합니다.
 */
export function createPopup({use_welcome}: PopupVo): Popup {
  return {
    useWelcome: use_welcome,
  };
}
